/* eslint-disable react/no-unescaped-entities */
import React from 'react'

const Error: React.FC = () => (
  <div>
    <h2 className="errorText">
      Sorry, you’ve caught us offline. We’re currently updating the platform with new features to improve your
      experience.
    </h2>
    <h2 className="errorText">We'll be back online shortly.</h2>
  </div>
)

export default Error
